import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import MUIDataTable from "mui-datatables";
import { Button } from 'reactstrap';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

 
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    fetchRangeIronPlay,
    fetchRangeFairway,
    fetchRangeDriver,
    fetchRangeSpeciality
 } from 'Actions';

 import AddItem from '../../../rangeintervention/longgame/component/addform';

class LongItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student: this.props.data.student,
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,
            selfrom:0,   
            listdiv:true,
            adddiv:false,
            
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
    }

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchRangeIronPlay(student, stdate, eddate);
        this.props.fetchRangeFairway(student, stdate, eddate);
        this.props.fetchRangeDriver(student, stdate, eddate);
        this.props.fetchRangeSpeciality(student, stdate, eddate);

        this.setState({
            adddiv:false,
            listdiv:true, 
        }); 
    }

    onAddSession(seltid) {
		this.setState({ 
         selfrom:seltid,
         listdiv:false,
         adddiv:true,
      });
    }



render() {
      
    const { rangeironplaylist, rangefairwaylist, rangedriverlist, rangespeciallist, loading} = this.props; 
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "date", label: "DATE" },
        { name: "coach", label: "COACH" },
        { name: "obsert", label: "OBSERVATION" },
        { name: "work", label: "WORK IN PROGRESS" },
      
    ];

    const tabledata1=rangeironplaylist.map((assmntval,idx) => {     
        
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });

    const tabledata2=rangefairwaylist.map((assmntval,idx) => {     
       
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });

    const tabledata3=rangedriverlist.map((assmntval,idx) => {     
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });

    const tabledata4=rangespeciallist.map((assmntval,idx) => {     
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });


      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> LONG GAME</h1>
                </div>

                <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                    <div className="ddd">
                        <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><i className="zmdi ti-angle-double-left"></i>  Back To Range</Button></div>
                        
                    </div>
                </div>
                {this.state.listdiv && 
                   <>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="IRON PLAY" fullBlock>
                        <MUIDataTable 
                                title={<div><Button onClick={ ()=>this.onAddSession(1)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Iron Play Intervention</Button></div>}                              
                                data={tabledata1}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="FAIRWAY WOODS" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(2)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Fairway Intervention</Button></div>}
                                data={tabledata2}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="DRIVER" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(3)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Driver Intervention</Button></div>}
                                data={tabledata3}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="SPECIALITY SHOTS" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(4)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Speciality Shot</Button></div>}
                                data={tabledata4}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    </>
                }  

                {this.state.adddiv && 
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }  
               
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ rangelonggame}) => {
   
    const { rangeironplaylist, rangefairwaylist, rangedriverlist, rangespeciallist, loading } = rangelonggame;
	return {  rangeironplaylist, rangefairwaylist, rangedriverlist, rangespeciallist, loading };   
}


export default connect(mapStateToProps, {
    fetchRangeIronPlay,
    fetchRangeFairway,
    fetchRangeDriver,
    fetchRangeSpeciality
})(LongItems);
